import { render, staticRenderFns } from "./tournamentMatches.vue?vue&type=template&id=079a5975&scoped=true&"
import script from "./tournamentMatches.vue?vue&type=script&lang=js&"
export * from "./tournamentMatches.vue?vue&type=script&lang=js&"
import style0 from "./tournamentMatches.vue?vue&type=style&index=0&id=079a5975&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079a5975",
  null
  
)

export default component.exports